export const getFileFormData = (files: FileList): FormData => {
  const file = files[0];
  const formData = new FormData();
  formData.append("file", file);

  return formData;
};
